export const FETCH_VENDORS_SUCCESS = 'FETCH_VENDORS_SUCCESS';
export const FETCHING_VENDORS = 'FETCHING_VENDORS';


// WEBPACK FOOTER //
// ./src/redux/vendors/VendorsConstants.js